export default "__VITE_ASSET__C$RGSmhC__"